import axios from "axios";

// Base URLs for Bitbucket API
export const BITBUCKET_API_BASE_URL = "https://api.bitbucket.org/2.0";
export const BITBUCKET_AUTH_URL = "https://bitbucket.org/site/oauth2/authorize";
export const BITBUCKET_TOKEN_URL =
  "https://bitbucket.org/site/oauth2/access_token";

// You'll need to register your app with Bitbucket to get these
export const CLIENT_ID = process.env.REACT_APP_BITBUCKET_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_BITBUCKET_CLIENT_SECRET;
export const REDIRECT_URI =
  process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000/callback";

// Get default workspace from environment variable
export const DEFAULT_WORKSPACE = process.env.REACT_APP_DEFAULT_WORKSPACE || "";

// Create an axios instance for Bitbucket API calls
export const bitbucketClient = axios.create({
  baseURL: BITBUCKET_API_BASE_URL,
});

// Add auth token interceptor
bitbucketClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("bitbucket_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Cache for repositories and workspaces
const cache = {
  repositories: {},
  workspaces: null,
  timestamp: {},
  // Cache validity in milliseconds (5 minutes)
  maxAge: 5 * 60 * 1000,
};

// Clear cache helper
export const clearCache = () => {
  cache.repositories = {};
  cache.workspaces = null;
  cache.timestamp = {};
};

// Now fix the invalidateRepositoryCache function
export const invalidateRepositoryCache = (workspace, repoSlug = null) => {
  const cacheKey = workspace || "all";

  if (repoSlug) {
    // If we modify a specific repository, we should also invalidate the workspace cache
    delete cache.timestamp[cacheKey];
  } else {
    // If no specific repo is provided, invalidate the entire workspace
    delete cache.repositories[cacheKey];
    delete cache.timestamp[cacheKey];
  }
};
